import { Attributes } from 'react';
import { StyleSheet } from 'react-native';

export type CustomStyles<K> = {
  customStyles: StyleSheet.NamedStyles<K>;
};

export function withCustomStyles<T extends Attributes, K>(
  Component: React.ComponentType<T & CustomStyles<K>>,
  style: StyleSheet.NamedStyles<K>,
) {
  return (props: T) => {
    return <Component customStyles={style} {...props} />;
  };
}
